export { default } from './QuickPay';
